import { FilterTypes } from '@cbre/components';
import { permissionLevelMap } from '../../property-set-details/permissions/permission';
import { PropertyColumns } from '@miq/catalog';

export const getFilters = () =>
  [
    {
      key: 'markets',
      value: 'Market',
      type: FilterTypes.Multi,
      dataType: 'text',
      inputType: 'dropdown',
      field: 'usages/lig_geography.market_desc',
    },
    {
      key: 'property_types',
      type: FilterTypes.Multi,
      value: 'Property Type',
      dataType: 'text',
      inputType: 'dropdown',
      field: 'usages/ref_property_usage_type_desc',
    },
    {
      key: 'is_statistical',
      type: FilterTypes.Multi,
      dataType: 'boolean',
      lookupCategory: '/lookup/yn',
      value: 'Statistical',
      inputType: 'dropdown',
      field: 'is_statistical',
    },
    {
      key: 'publishing_sector',
      type: FilterTypes.Multi,
      value: 'Publishing Sector',
      inputType: 'dropdown',
      dataType: 'text',
      field: 'publishing_sector',
    },
    {
      key: 'publishing_group',
      type: FilterTypes.Multi,
      value: 'Publishing Group',
      inputType: 'dropdown',
      dataType: 'text',
      field: 'publishing_group',
    },
    {
      key: 'permission_level',
      type: FilterTypes.Multi,
      value: 'My Access Level',
      inputType: 'dropdown',
      dataType: 'numeric',
      field: 'permission_level',
      options: Object.entries(permissionLevelMap).map(([key, value]) => ({ key, value })),
    },
    {
      key: 'shared_with',
      value: 'Shared With',
      placeholder: 'VALUE',
      type: FilterTypes.Group,
      inputType: 'text',
      field: 'shared_with',
      associations: [
        {
          key: 'shared_user_permission_desc',
          value: 'Shared With',
          placeholder: 'VALUE',
          dataType: 'text',
          type: FilterTypes.EqualNoCase,
          inputType: 'text',
          field: 'shared_user_permission_desc',
        },
        {
          key: 'shared_user_permission',
          value: 'Shared Access Level',
          placeholder: 'VALUE',
          type: FilterTypes.Equal,
          inputType: 'dropdown',
          dataType: 'numeric',
          field: 'shared_user_permission',
          showLabel: true,
        },
      ],
    },
    {
      key: 'create_by',
      value: 'Created By',
      placeholder: 'VALUE',
      dataType: 'text',
      type: FilterTypes.EqualNoCase,
      inputType: 'text',
      field: 'create_by',
    },
    {
      key: 'create_ts',
      type: FilterTypes.Range,
      dataType: 'date',
      inputType: 'date',
      value: 'Created On',
      field: 'create_ts',
    },
  ].map(f => ({ ...f }));

export const CATALOG_KNOWN_FILTERS = {
  markets: PropertyColumns.Location_Market,
  property_types: PropertyColumns.PropertyTypeDetails_Type,
};
